import { createContext, useReducer, useState } from "react";
import { loggedInNameInit, loggedInStateInit, loggedInUserReducer, loggedInUserRolesInit } from "./reducer/LoggedInUserReducer";
import { alertInitialState, alertNotifierReducer } from "./reducer/AlertNotifierReducer";
import { getSessionStorage } from "../service/SessionStorageService";
import { Constants } from "../utils/Constants";
import { getActiveRole } from "../utils/Utils";
import { notificationBannerInitialState, notificationBannerReducer } from "./reducer/NotificationBannerReducer";

export const AppContext = createContext({});

export const AppProvider = ({ children }) => {
	const [loggedInUser, setLoggedInUser] = useReducer(loggedInUserReducer, null, loggedInStateInit);
	const [name, setName] = useReducer(loggedInUserReducer, null, loggedInNameInit)
	const [roles, setRoles] = useReducer(loggedInUserReducer, null, loggedInUserRolesInit)
	const [alert, setAlert] = useReducer(alertNotifierReducer, alertInitialState);
	const [showBanner, setShowBanner] = useReducer(notificationBannerReducer, notificationBannerInitialState);
	const userRoles = roles?.length ? roles : getSessionStorage(Constants.rolesState)
	const [activeRole, setActiveRole] = useState(getActiveRole(userRoles))
	const [regSearchParams, setRegSearchParams] = useState({})
	const [entitlementSearchParams, setEntitlementSearchParams] = useState({})
	const [toggleNav, setToggleNav] = useState(true)
	const [route, setRoute] = useState('/');
	const [showLoader, setShowLoader] = useState(false)

	const store = {
		loggedInUser, setLoggedInUser,
		name, setName,
		roles, setRoles,
		activeRole, setActiveRole,
		alert, setAlert,
		toggleNav, setToggleNav,
		route, setRoute,
		regSearchParams, setRegSearchParams,
		entitlementSearchParams, setEntitlementSearchParams,
		showLoader, setShowLoader,
		showBanner, setShowBanner
	};

	return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};
